module.exports = __webpack_public_path__ + "static/media/EchoMountainlogo2016.b3ddf634.webp";